import { observer } from 'mobx-react-lite'
import { useLoaderData } from 'react-router'
import { ProfileContainer } from '@/features/iam/users/Profile/ProfileContainer'
import type { ProfileViewLoaderData } from '@/features/iam/iam-route-loaders'

export default observer(function WorkspaceProfileContainer() {
  const data = useLoaderData<ProfileViewLoaderData>()
  return data && <ProfileContainer vm={data.vm} />
})
